var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigCommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#34313F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.291 27.29h6.05c1.721 0 2.81-.947 2.81-2.467 0-1.434-1.089-2.467-2.81-2.467h-6.05c-.2 0-.372.172-.372.345v4.243c.027.2.17.345.372.345zm0 9.777h6.251c1.921 0 3.068-.975 3.068-2.696 0-1.492-1.089-2.696-3.068-2.696h-6.251c-.2 0-.372.171-.372.345v4.675c.027.229.17.372.372.372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.428.106 29.534 17.942h2.925c4.56 0 7.255 2.867 7.255 5.992 0 2.467-1.663 4.273-3.441 5.076-.287.116-.287.516.029.63 2.063.804 3.526 2.954 3.526 5.476 0 3.556-2.38 6.394-6.997 6.394H20.158c-.2 0-.372-.171-.372-.345V27.66L.143 47.218c-.259.258-.087.716.287.716h47.227a.319.319 0 0 0 .316-.316V.364c.085-.316-.316-.487-.545-.258z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCommerce);
export default __webpack_public_path__ + "static/media/BigCommerce.a26b603eaa41c159f7561973fccf5458.svg";
export { ForwardRef as ReactComponent };